<template>
  <div>
    <div class="integrationSuccessPop" v-if="success == 1">
      <p v-translate="{importCount: importCount}">%{importCount} shippings are being imported.</p>
      <p v-translate="{userEmail: userEmail}">In case of errors we will send and email with the details to <span>%{userEmail}</span></p>
    </div>
    <div class="integrationSuccessPop" v-else>
      <p v-translate="{importCount: importCount}">There was an error your %{importCount} shippings are not being imported.</p>
      <p>{{message}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IntegrationImportShopifyShippingsMessage',
  props: {
    success: {
      required: true
    },
    importCount: {
      type: Number,
      required: true
    },
    userEmail: {
      type: String,
      required: true
    },
    message: {
      Type: String,
      required: false,
      default: () => { return '' }
    }
  }
}
</script>
<style lang="scss">
div.integrationSuccessPop p {
  font-size:150%;
}
div.integrationSuccessPop p span {
  color:#4fa0ff;
}
</style>
